/** The collections a subscription rule scope may target: the owning org, or one of its sites. */
export const NOTIFICATION_SCOPE_COLLECTIONS = ["organizations", "areaOfInterest"] as const;

export type NotificationScopeCollection = (typeof NOTIFICATION_SCOPE_COLLECTIONS)[number];

/** Organizations and areasOfInterest are both looked up by `_id`, so every scope resolves its target by it. */
export const SCOPE_TARGET_FOREIGN_FIELD = "_id" as const;
